function computeDurationInMonths(duration) {
    if ('years' in duration) {
        return duration.years * 12;
    }
    return duration.months;
}
// This function calculates the total return on an investment over a specified duration.
export function computePensionReturn(options) {
    if ([
        options.initialAmount,
        options.monthlyPayment,
        options.fixedMonthlyFee,
        options.yearlyFeePercentage,
        options.yearlyYieldPercentage,
    ].some(function (value) { return value < 0; })) {
        return {
            ok: false,
            error: new Error('all values used must be positive'),
        };
    }
    // Calculate the total number of months the investment will last.
    var numberOfMonths = computeDurationInMonths(options.duration);
    // Set the initial amount of money in the account.
    var accountMoney = options.initialAmount;
    for (var i = 0; i < numberOfMonths; i++) {
        // Add the monthly payment to the account balance.
        accountMoney += options.monthlyPayment;
        // Calculate the dynamic fee based on the account balance and monthly fee percentage
        var dynamicFee = Math.ceil(accountMoney *
            (Math.pow((1 + options.yearlyFeePercentage / 100), (1 / 12)) - 1) *
            100) / 100;
        // Calculate the monthly interest earned on the account balance.
        var monthlyInterest = Math.ceil(accountMoney *
            (Math.pow((1 + options.yearlyYieldPercentage / 100), (1 / 12)) - 1) *
            100) / 100;
        // Update the account balance by subtracting fees and adding interest earned.
        accountMoney += monthlyInterest - dynamicFee - options.fixedMonthlyFee;
    }
    // Return the total account balance after the investment duration, rounded to two decimal places.
    return { ok: true, value: Math.ceil(accountMoney * 100) / 100 };
}
// This function calculates the industry standard (5%) up-front fee. This is not Feather's up-front fee.
export function computeIndustryUpFrontFee(options) {
    if ([options.initialAmount, options.monthlyPayment].some(function (value) { return value < 0; })) {
        return {
            ok: false,
            error: new Error('all values used must be positive'),
        };
    }
    // Calculate the total number of months the investment will last.
    var numberOfMonths = computeDurationInMonths(options.duration);
    var totalMonthlyContribution = options.monthlyPayment * numberOfMonths;
    var totalContribution = totalMonthlyContribution + options.initialAmount;
    var upFrontFee = totalContribution * 0.05;
    return { ok: true, value: Math.ceil(upFrontFee * 100) / 100 };
}
